import React, { useState } from 'react';
import { apiPost } from '../api/client';
import type { CheckoutSessionResponse } from '../types/api';
import './SubscribeModal.css';

interface Props {
  vaultId: string;
  onClose: () => void;
}

export default function SubscribeModal({ vaultId, onClose }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubscribe(interval: 'monthly' | 'yearly') {
    setLoading(true);
    setError('');
    try {
      const data = await apiPost<CheckoutSessionResponse>(
        `/api/vault/${vaultId}/billing/checkout`,
        { billingInterval: interval }
      );
      window.location.href = data.checkoutUrl;
    } catch (err: any) {
      setError(err.message || 'Unable to start checkout. Please try again.');
      setLoading(false);
    }
  }

  return (
    <div className="subscribe-modal-backdrop" onClick={onClose}>
      <div className="subscribe-modal" onClick={e => e.stopPropagation()}>
        <button className="subscribe-modal-close" onClick={onClose} aria-label="Close">✕</button>

        <h2 className="subscribe-modal-title">Subscribe to Cedar Vault</h2>
        <p className="subscribe-modal-subtitle">
          Keep your family's most important information safe and accessible — forever.
        </p>

        <div className="subscribe-modal-plans">
          <div className="subscribe-plan">
            <div className="subscribe-plan-name">Monthly</div>
            <div className="subscribe-plan-price">$11.99<span className="subscribe-plan-period">/month</span></div>
            <button
              className="btn-primary subscribe-plan-btn"
              onClick={() => handleSubscribe('monthly')}
              disabled={loading}
            >
              {loading ? 'Redirecting…' : 'Subscribe Monthly'}
            </button>
          </div>

          <div className="subscribe-plan subscribe-plan--featured">
            <div className="subscribe-plan-badge">Best Value</div>
            <div className="subscribe-plan-name">Yearly</div>
            <div className="subscribe-plan-price">$99<span className="subscribe-plan-period">/year</span></div>
            <div className="subscribe-plan-savings">Save $45 — over 3 months free</div>
            <button
              className="btn-primary subscribe-plan-btn"
              onClick={() => handleSubscribe('yearly')}
              disabled={loading}
            >
              {loading ? 'Redirecting…' : 'Subscribe Yearly'}
            </button>
          </div>
        </div>

        {error && <p className="subscribe-modal-error">{error}</p>}

        <p className="subscribe-modal-fine-print">
          You'll be taken to Stripe's secure checkout. Cancel anytime from your billing portal.
        </p>
      </div>
    </div>
  );
}
